import React from 'react'
import { Route, Redirect } from "react-router-dom"

import MenuBar from '../components/MenuBar'
import FixedMenuBar from '../components/FixedMenuBar'
import NavBar from '../components/NavBar'
import Recipe from './Recipe'
import Pantry from './Pantry'
import SocialFeed from './SocialFeed'

export default function Home({match}) {
    return (
        <div className='Home'>
            {/* <MenuBar/> */}
            <FixedMenuBar />
            <Redirect to={`${match.url}/pantry`}/>
            <Route path={`${match.url}`} component={NavBar}/>
            <Route path={`${match.url}/recipes`} component={Recipe}/>
            <Route path={`${match.url}/pantry`} exact component={Pantry}/>
            <Route path={`${match.url}/socialfeed`} component={SocialFeed}/>
        </div>
    )
}
